import React, { useState } from "react";
import {
  Button,
  Radio,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Box,
} from "@mui/material";
import Alert from "@mui/material/Alert";

function NewTripForm5({ nextStep, prevStep, handleChange, values }) {
  const [errors, setErrors] = useState({});

  const formIsValid = () => {
    const formErrors = {};
    const { brdstckArea } = values;

    if (
      !brdstckArea.GOMDA &&
      !brdstckArea.INSHORE &&
      !brdstckArea.OFFSHORE &&
      !brdstckArea.SNEDA
    ) {
      formErrors.brdstckArea = "At least one Area must be selected.";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };
  const _next = (event) => {
    event.preventDefault();
    if (!formIsValid()) return;

    nextStep();
  };
  const _cancel = (event) => {
    event.preventDefault();
    prevStep();
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <FormControl variant="standard" component="fieldset">
          <FormLabel component="legend">
            Will you be using a Northeast Multispecies Day-At-Sea?
          </FormLabel>
          <RadioGroup
            name="ne_multiflg"
            id="ne_multiflg"
            value={values.neMultiFlg}
            onChange={handleChange("neMultiFlg")}
            row
            className="justifyCenter"
          >
            <FormControlLabel
              value="true"
              control={<Radio color="primary" />}
              label="Yes"
            />
            <FormControlLabel
              value="false"
              control={<Radio color="primary" />}
              label="No"
            />
          </RadioGroup>
        </FormControl>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <FormControl variant="standard" component="fieldset">
          <FormLabel component="legend">Broadstock Areas</FormLabel>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={values.brdstckArea.GOMDA}
                  name="GOMDA"
                  onChange={handleChange("brdstckArea")}
                />
              }
              label="Gulf of Maine"
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={values.brdstckArea.INSHORE}
                  name="INSHORE"
                  onChange={handleChange("brdstckArea")}
                />
              }
              label="Inshore Georges Bank"
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={values.brdstckArea.SNEDA}
                  name="SNEDA"
                  onChange={handleChange("brdstckArea")}
                />
              }
              label="Southern New England"
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={values.brdstckArea.OFFSHORE}
                  name="OFFSHORE"
                  onChange={handleChange("brdstckArea")}
                />
              }
              label="Offshore Georges Bank"
            />
          </FormGroup>
        </FormControl>
      </Box>
      {errors.brdstckArea && (
        <Alert severity="error">{errors.brdstckArea}</Alert>
      )}
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Back
          </Button>
        </Box>
        <Box p={1}>
          <Button variant="contained" className="successBtn" onClick={_next}>
            Continue
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default NewTripForm5;
